import { svg, SVGTemplateResult } from "lit";

/** Bandcamp brand icon (24×24, fill=currentColor) */
export const bandcampIcon: SVGTemplateResult = svg`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M0 18.75l7.437-13.5H24l-7.438 13.5H0z"/>
  </svg>`;
